// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import { useMediaQuery, useTheme } from "@mui/material";

import { Grid, Box, Video } from "@/components/core";

export function AccountEntranceVideo() {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid spacing={isMobile ? 0 : 3}>
      <Grid.Item xs={12}>
        <Box
          sx={{
            width: "100%",
            minHeight: "100vh",
            overflow: "hidden",
          }}
        >
          <Video
            src="/video/media1.mp4"
            autoPlay
            muted
            loop
            playsInline
            controls={false}
            disablePictureInPicture
            controlsList="nodownload nofullscreen noremoteplayback"
            sx={{
              position: "absolute",
              right: 0,
              width: "auto",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Box>
      </Grid.Item>
    </Grid>
  );
}
